import Image from "next/image";
import Link from "next/link";
import { useMemo } from "react";
import { Box } from "@mui/material";

interface LogoProps {
    variant: 'icon' | 'text' | 'iconAndText',
    linkToRoot?: boolean
}

const imageBaseUrl = "/assets/logo";
const imageAlt = "Museum Erding logo";

export default function Logo({ variant = 'iconAndText', linkToRoot = false }: LogoProps) {

    const logoVariant = useMemo(() => {
        switch (variant) {
            case 'iconAndText':
                return <IconAndTextVariant />;
            case 'icon':
                return <IconOnlyVariant />;
            case "text":
                return <TextOnlyVariant />;
        }
    }, [variant]);


    if (linkToRoot) {
        return (
            <Link
                href="/"
                prefetch
                style={{ display: 'inline-flex', minHeight: 24 }}
            >
                {logoVariant}
            </Link>
        )
    } else {
        return logoVariant;
    }
}

function IconAndTextVariant() {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <Image
                src={`${imageBaseUrl}/logo_small_icon_and_text.webp`}
                alt={imageAlt}
                width={100}
                height={80}
                style={{
                    height: 'auto',
                    width: '100%',
                    padding: 2
                }}
                priority
            />
        </Box>
    )
}

function IconOnlyVariant() {
    return (
        <Image
            src={`${imageBaseUrl}/logo_small_icon_only.webp`}
            alt={imageAlt}
            sizes="100vw"
            style={{
                height: 'auto',
                width: 'auto',
                aspectRatio: '1 / 1',
                padding: 4
            }}
            width={100}
            height={60}
            priority
        />
    )
}

function TextOnlyVariant() {
    return (
        <Image
            src={`${imageBaseUrl}/logo_small_text_only.webp`}
            alt={imageAlt}
            sizes="100vw"
            style={{
                height: 'auto',
                width: 'auto',
            }}
            width={100}
            height={60}
            priority
        />
    )
}
